/**
 * The default fiverr locale to be used - English.
 * @type {String}
 */
export const DEFAULT_LOCALE = 'en-US';

/**
 * A mapping of specific locales to subdomains (default is the locale itself).
 * @type {Object<String>}
 */
export const LOCALE_TO_SUBDOMAIN_MAP = {
    [DEFAULT_LOCALE]: 'www',
    'de-DE': 'de',
    'es': 'es',
    'fr-FR': 'fr',
    'pt-BR': 'br',
    'it-IT': 'it',
    'nl-NL': 'nl'
};

/**
 * The site's default subdomain.
 * @type {String}
 */
export const DEFAULT_SUBDOMAIN = 'www';

/**
 * The site's domain name.
 * @type {String}
 */
export const DOMAIN_NAME = 'fiverr.com';

/**
 * When false, the user will not receive realtime notifications.
 */
export const DEFAULT_REALTIME_ENABLED = true;

/**
 * When true, realtime notifications will play a sound on arrival.
 */
export const DEFAULT_SOUND_ENABLED = true;
